import { isEmptyObject } from '../validators/formValidators';
import { getTodayDateTZ } from './../helpers/utils';

const defaultState = {
    rows: undefined,
    total: 0,
    caseIds: [],
    paging: { page: 0, pageSize: 30, sort: undefined, desc: false, append: false },
    loadingPage: false,
    current: {},
    newForClient: {},
    templates: undefined,
    refreshNeeded: true,
    loadingCurrent: false,
    savingNeeded: false,
    filter: undefined,
    tabState: undefined,
    states: undefined,
    headers: undefined,
    _serverError: undefined,
    _serverSuccess: undefined,
    _loadingDocumentTemplates: false,
};

export const casesReducer = (state = defaultState, action) => {
    let files;
    let result;
    let current;
    let events;
    let signings;
    let payments;
    let index;
    let id;
    let hash;
    let sms;
    let charges;
    let data;
    switch (action.type) {
        case 'CASE_SET_SERVER_ERROR':
            return {
                ...state,
                _serverError: action.error,
            };

        case 'CASE_SET_SERVER_SUCCESS':
            return {
                ...state,
                _serverSuccess: action.success,
            };

        case 'CASES_LOAD_SUCCESS':
            data = action.result.data;
            return {
                ...state,
                // Scrolling to the end appends the next page; anything else replaces the rows.
                rows: action.append && state.rows
                    ? [...state.rows, ...data.cases.filter(c => !state.rows.some(r => r.id === c.id))]
                    : [...data.cases],
                // Unpaged responses carry every case.
                total: data.total !== undefined ? data.total : data.cases.length,
                caseIds: data.caseIds || data.cases.map(v => v.id),
                // The server clamps the page when the result set shrank.
                paging: data.page !== undefined ? { ...state.paging, page: data.page, append: false } : state.paging,
                refreshNeeded: false,
                loadingPage: false,
                loadingCurrent: false
            };

        case 'CASES_LOAD_REQUEST':
            return {
                ...state,
                refreshNeeded: false,
                loadingPage: true,
            };

        case 'CASES_LOAD_FAILURE':
            return {
                ...state,
                loadingCurrent: false,
                loadingPage: false,
                refreshNeeded: true,
            };

        case 'CASES_PAGING':
            // Keep the current rows on screen while the new page loads.
            return {
                ...state,
                paging: { ...state.paging, append: false, ...action.paging },
                refreshNeeded: true,
            };

        case 'CASES_FILTER':
            return {
                ...state,
                filter: action.filter
            };

        case 'CASES_COLUMNS_SET_REQUEST':
            return {
                ...state,
                headers: [...action.headers]
            };


        case 'CASE_NEW_FOR_CLIENT':
        return {
                ...state,
                newForClient: {...action.client},
                current: {client: {...action.client}},
            };

        case 'CASE_NEW':
            result = {
                ...state,
                loadingCurrent: false,
                savingNeeded: false,
                newForClient: {}
            };

            result.tabState = 'new';
            result.current = {client: {...state.newForClient}};
            return result;

        case 'CASE_EDIT':
            current = {};
            if (action.clear) {
                current = { ...action.current };
            } else {
                current = { ...state.current, ...action.current };
            }

            current['CaseType'] = current.intake && current.intake['CaseType'];
            result = {
                ...state,
                current,
                loadingCurrent: false,
            };

            result.tabState = 'edit';
            return result;

        case 'CASE_CLIENT_SET':
            current = {...state.current};
            current.client = {...action.currentClient};
            return {
                ...state,
                current,
                loadingCurrent: false,
            };

        case 'CASES_IMPORT_SUCCESS':
        case 'CASES_SET_CASE_STATES_SUCCESS':
        case 'CASES_DELETE_IDS_SUCCESS':
        case 'CASE_DELETE_ID_SUCCESS':
            return {
                ...state,
                refreshNeeded: true
            };

        case 'CASE_EDIT_ID_REQUEST':
            return {
                ...state,
                current: {
                    ...action.initialCase,
                    _loadingAllEvents: true,
                    _loadingEmails: true,
                    _loadingFaxes: true,
                    _loadingSms: true,
                },
                loadingCurrent: true,
            };

        case 'CASE_EDIT_ID_SUCCESS':
            current = {
                ...action.result.data.case, 
                ...action.result.data.events, 
                tasks: { ...action.result.data.tasks },
                _loadingAllEvents: false,
                _loadingEmails: false,
                _loadingFaxes: false,
                _loadingSms: false,
            };

            current['CaseType'] = current.intake && current.intake['CaseType'];
            result = {
                ...state,
                current,
                loadingCurrent: false,
            };

            result.tabState = 'edit';
            return result;

        case 'CASE_EDIT_ID_FAILURE':
            return {
                ...state,
                current: {
                    _loadingAllEvents: false,
                    _loadingEmails: false,
                    _loadingFaxes: false,
                    _loadingSms: false,
                },
                loadingCurrent: false,
            };

        case 'CASE_REFRESH_REQUEST':
            return {
                ...state,
                loadingCurrent: true,
                current: {
                    ...state.current,
                    _loadingAllEvents: true,
                    _loadingEmails: true,
                    _loadingFaxes: true,
                    _loadingSms: true,
                }
            }

        case 'CASE_REFRESH_SUCCESS':
            current = {...action.result.data.case, ...action.result.data.events, tasks: { ...action.result.data.tasks }};
            current['CaseType'] = current.intake && current.intake['CaseType'];
            result = {
                ...state,
                loadingCurrent: false,
                current: {
                    ...state.current,
                    _loadingAllEvents: false,
                    _loadingEmails: false,
                    _loadingFaxes: false,
                    _loadingSms: false,
                }
            };

            if (state.current && state.current.id === current.id) {
                result = {
                    ...result,
                    current
                };
            }

            if (state.rows && state.rows.length > 0) {
                let index = state.rows.findIndex(v => v.id === current.id);
                if (index >= 0) {
                    let rows = [...state.rows];
                    rows[index] = current;
                    result = {
                        ...result,
                        rows
                    };
                }
            }
            
            return result;

        case 'CASE_REFRESH_FAILURE':
            return {
                ...state,
                loadingCurrent: false,
                current: {
                    ...state.current,
                    _loadingAllEvents: false,
                    _loadingEmails: false,
                    _loadingFaxes: false,
                    _loadingSms: false,
                }
            };

        case 'CASE_EMAILS_GET_REQUEST':
            return {
                ...state,
                current: {...state.current, emails: [], _loadingEmails: true },
            };

        case 'CASE_EMAILS_GET_FAILURE':
            return {
                ...state,
                current: {...state.current, emails: undefined, _loadingEmails: false },
            };

        case 'CASE_EMAILS_GET_SUCCESS':
            return {
                ...state,
                current: {...state.current, emails: [...action.result.data], _loadingEmails: false },
            };

        case 'CASE_EMAIL_ADD':
            if (state.current.id != action.caseId) {
                return {...state};
            }

            let emails = [];
            if (state.current && state.current.emails) {
                emails = [...state.current.emails];
            }

            emails.unshift(action.email);
            return {
                ...state,
                current: {...state.current, emails: [...emails]}
            };

        case 'CASES_ALL':
            result = {
                ...state,
                current: {}
            };

            result.tabState = 'all';
            return result;

        case 'CASE_SAVING_NEEDED':
            current = {...state.current};
            if (current.intake && current.intake['CaseType']) {
                current['CaseType'] = current.intake && current.intake['CaseType'];
            }

            return {
                ...state,
                savingNeeded: action.savingNeeded,
                current
            };

        case 'CASES_REFRESH_NEEDED':
            let rows = undefined;
            if (!action.refreshNeeded) {
                rows = [...state.rows];
            }

            return {
                ...state,
                refreshNeeded: action.refreshNeeded,
                rows
            };

        case 'TEMPLATE_DELETE_SUCCESS':
            let templatesDelete = {...state.templates};
            let templateType = action.result.data.templateType;
            let templateName = action.result.data.templateName;
            index = templatesDelete[templateType].findIndex(v => v.fileName === templateName);
            if (index > -1) {
                templatesDelete[templateType].splice(index, 1);
            }

            return {
                ...state,
                templates: templatesDelete
            };

        case 'TEMPLATE_ADD':
            let templates = {};
            if (state.templates) {
                templates = {...state.templates};
            }

            if (!templates[action.templateType]) {
                templates[action.templateType] = [{
                    fileName: action.templateName,
                    Size: action.size,
                    LastModified: getTodayDateTZ(undefined, false),
                }];

            } else {
                if (!templates[action.templateType].find(v => v.fileName === action.templateName)) {
                    templates[action.templateType].unshift({
                        fileName: action.templateName,
                        Size: action.size,
                        LastModified: getTodayDateTZ(undefined, false),
                    });
                }
            }

            return {
                ...state,
                templates
            };

        case 'CASE_FILES_LOAD_REQUEST':
            return {
                ...state,
                current: {
                    ...state.current,
                    _loadingFiles: true,
                }
            }

        case 'CASE_FILES_LOAD_SUCCESS':
            files = {};
            if (!isEmptyObject(action.result.data)) {
                files = {...action.result.data};
            }

            return {
                ...state,
                current: {...state.current, files, _loadingFiles: false },
            };

        case 'CASE_FILES_LOAD_FAILURE':
            return {
                ...state,
                current: {...state.current, _loadingFiles: true }, // Keep loading files true so that the network is not getting hammered.
            };


        case 'CASE_FILE_DELETE_SUCCESS':
            if (state.current.id != action.result.data.caseId) {
                return {...state };
            }

            files = {...state.current.files};
            let fileType = action.result.data.fileType;
            let fileName = action.result.data.fileName;
            index = files[fileType].findIndex(v => v.fileName === fileName);
            if (index > -1) {
                files[fileType].splice(index, 1);
            }

            return {
                ...state,
                current: {...state.current, files},
            };

        case 'CASE_FILE_ADD':
            if (state.current.id != action.caseId) {
                return { ...state };
            }

            files = {};
            if (state.current.files) {
                files = {...state.current.files};
            }

            if (!files[action.fileType]) {
                files[action.fileType] = [{
                    fileName: action.fileName,
                    Size: action.size,
                    LastModified: getTodayDateTZ(undefined, false),
                }];

            } else {
                if (!files[action.fileType].find(v => v.fileName === action.fileName)) {
                    files[action.fileType].unshift({
                        fileName: action.fileName,
                        Size: action.size,
                        LastModified: getTodayDateTZ(undefined, false),
                    });
                }
            }

            return {
                ...state,
                current: {...state.current, files}
            };

        case 'FAX_STATUS_REQUEST':
            return {
                ...state,
                current: {...state.current, _loadingFaxes: true },
            };

        case 'FAX_STATUS_SUCCESS':
            current = { ...state.current, _loadingFaxes: false };
            let faxesPoll = {};
            if (!isEmptyObject(action.result.data)) {
                faxesPoll = { ...action.result.data };
            }

            if (!isEmptyObject(current) &&
                faxesPoll.pollResults &&
                faxesPoll.caseId == current.id) {

                current.faxesPoll = faxesPoll;

            } else {
                current.faxesPoll = undefined;
            }

            return {
                ...state,
                current: current,
            };

        case 'FAX_STATUS_FAILURE':
            return {
                ...state,
                current: {...state.current, _loadingFaxes: false },
            };

        case 'CASE_STATES_LOAD_SUCCESS':
            return {
                ...state,
                states: [...action.result.data]
            };

        case 'CASE_LAWPAY_PAY_SUCCESS':
        case 'CASE_PAYPAL_ORDER_APPROVE_SUCCESS':
            charges = [];
            let charge = action.result.data.charge;
            if (!charge) {
                return  state;
            }

            if (state.current.charges) {
                charges = [...state.current.charges];
            }

            let index3 = charges.findIndex(value => {
                return value.id === charge.id;
            });

            if (index3 < 0) {
                charges.unshift(charge);
            }

            return {
                ...state,
                current: {...state.current, charges},
                refreshNeeded: true,
            };

        case 'CASE_CHARGES_GET_SUCCESS':
            return {
                ...state,
                current: {...state.current, charges: [...action.result.data]}
            };

        case 'CASE_SET_CURRENT':
            return {
                ...state,
                current: {...state.current, ...action.case}
            };

    case 'CASE_EVENTS_LOAD_REQUEST':
            return {
                ...state,
                current: {
                    ...state.current,
                    _loadingAllEvents: false,
                    _loadingEmails: false,
                    _loadingFaxes: false
                },
            };

        case 'CASE_EVENTS_LOAD_SUCCESS':
            events = [];
            if (!isEmptyObject(action.result.data)) {
                events = {...action.result.data};
            }

            return {
                ...state,
                current: {...state.current, ...events},
            };

        case 'CASE_EVENTS_LOAD_FAILURE':
            return {
                ...state,
                current: {
                    _loadingAllEvents: false,
                    _loadingEmails: false,
                    _loadingFaxes: false,
                },
            };

        case 'CASE_SMS_GET_REQUEST':
            return {
                ...state,
                current: {...state.current, _loadingSms: true },
            };

        case 'CASE_SMS_GET_FAILURE':
            return {
                ...state,
                current: {...state.current, _loadingSms: false },
            };


        case 'CASE_SMS_GET_SUCCESS':
            if (!action.result.data) {
                events = [];
            } else {
                events = [ ...action.result.data ];
            }

            return {
                ...state,
                current: { ...state.current, sms: events },
            };

        case 'USER_SMS_SEND_SUCCESS':
            if (state.current && state.current.sms) {
                events = [...action.result.data.messages, ...state.current.sms];
            } else {
                events = [...action.result.data.messages];
            }

            return {
                ...state,
                current: { ...state.current, sms: events },
            };

        case 'CASE_EVENT_DELETE_SUCCESS':
            id = action.result.data.id;
            events = [];
            if (state.current && state.current.events) {
                events = [ ...state.current.events ];
            }

            charges = [];
            if (state.current && state.current.charges) {
                charges = [ ...state.current.charges ];
            }

            if (action.result.data.eventType === 'Charge') {
                charges = charges.filter(v => v.id !== id);
            } else {
                events = events.filter(v => v.id !== id);
            }

            return {
                ...state,
                current: { ...state.current, events, charges },
                refreshNeeded: true,
            };

        case 'CASE_SIGN_GENERATE_SUCCESS':
            signings = [];
            if (state.current && state.current.signings) {
                signings = [ ...state.current.signings ];
            }

            hash = { ...action.result.data };
            signings.unshift(hash);
            return {
                ...state,
                current: {
                    ...state.current,
                    signings
                },
            };

        case 'CASE_PAYMENT_GENERATE_SUCCESS':
            payments = [];
            if (state.current && state.current.payments) {
                payments = [ ...state.current.payments ];
            }

            hash = { ...action.result.data };
            payments.unshift(hash);
            return {
                ...state,
                current: {
                    ...state.current,
                    payments
                },
            };

        case 'CASE_EVENT_EDIT_SUCCESS':
            if (state.current.id !== (action.result.data['CaseId'] || action.result.data['$CaseId$'])) {
                return { ...state };
            }

            id = action.result.data.id;
            events = [];
            if (state.current && state.current.events) {
                events = [ ...state.current.events ];
            }

            charges = [];
            if (state.current && state.current.charges) {
                charges = [ ...state.current.charges ];
            }

            if (action.result.data['$PaymentService$']) {
                index = charges.findIndex(event => {
                    return event.id == id;
                });

                if (index != -1) {
                    charges[index] = action.result.data;

                } else {
                    charges.unshift(action.result.data);
                }
            } else {
                index = events.findIndex(event => {
                    return event.id == id;
                });

                if (index != -1) {
                    events[index] = action.result.data;

                } else {
                    events.unshift(action.result.data);
                }
            }

            return {
                ...state,
                current: { ...state.current, events, charges },
                refreshNeeded: true,
            };

        case 'IMPERSONATE_EMPLOYEE_SUCCESS':
            return { ...defaultState };

        case 'USER_TASK_UPDATE_SUCCESS':
            return {
                ...state,
                refreshNeeded: true,
            };

        case 'PUBLIC_CASE_GET_SUCCESS':
            return {
                ...state,
                current: { ...action.result.data.matter },
            };

        case 'CASE_PUBLIC_INTAKE_FORM_ALLOW_SUCCESS':
        case 'CASE_IS_PUBLIC_INTAKE_FORM_ENABLED_SUCCESS':
            return {
                ...state,
                current: {
                    ...state.current,
                    publicIntakeHash: action.result.data.hash,
                    publicIntakeEnabled: action.result.data.publicIntakeEnabled,
                }
            };

        case 'CASE_HASH_DELETE_SUCCESS':
            const hashId = action.result.data;
            if (state.current && state.current.signings) {
                signings = [ ...state.current.signings ].filter( v => v.hash !== hashId);
            }

            if (state.current && state.current.payments) {
                payments = [ ...state.current.payments ].filter( v => v.hash !== hashId);
            }

            return {
                ...state,
                current: {
                    ...state.current,
                    signings,
                    payments,
                }
            };

        case 'TEMPLATES_LOAD_REQUEST':
            return {
                ...state,
                _loadingDocumentTemplates: true
            };

        case 'TEMPLATES_LOAD_SUCCESS':
            return {
                ...state,
                templates: {...action.result.data},
                _loadingDocumentTemplates: false,
            };

        default:
            return state;
    }
};
